import { render, staticRenderFns } from "./ChuongTrinhForm.vue?vue&type=template&id=ad89f0e4&"
import script from "./ChuongTrinhForm.vue?vue&type=script&lang=js&"
export * from "./ChuongTrinhForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports